/**
 * Production-safe Logger Utility
 *
 * Only outputs to console in development mode.
 * Prevents Lighthouse CI console error penalties.
 *
 * @module utils/logger
 */

const isDev = import.meta.env.DEV;

type LogLevel = 'log' | 'warn' | 'error' | 'debug' | 'info';

function createLogger(level: LogLevel) {
  return (...args: unknown[]): void => {
    if (isDev) {
      // eslint-disable-next-line no-console
      console[level](...args);
    }
  };
}

export const logger = {
  log: createLogger('log'),
  warn: createLogger('warn'),
  error: createLogger('error'),
  debug: createLogger('debug'),
  info: createLogger('info'),

  /**
   * Always logs, even in production (for critical errors)
   * Use sparingly!
   */
  critical: (...args: unknown[]): void => {
    console.error('[CRITICAL]', ...args);
  },
};

export default logger;
